









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { FacetViewObject, MenuItem } from '@/types/apiServerContract';
import mobileNavigationAndFacetsOverlay from '@/project/modals/overlays/MobileNavigationAndFacetsOverlay.service';
import bus from '@/core/bus';
import { MobileFacetsUpdateEventKey } from '@/core/http/constants';
import { debounce } from 'lodash';

@Component({
    components: { }
})
export default class MobileNavigationAndFacets extends Vue {
    @Prop({ type: String, required: true })
    private contextKey!: string;

    @Prop({ type: Array })
    private readonly facets!: FacetViewObject[] | null;

    @Prop({ type: Object })
    private readonly rootMenuItem!: MenuItem | null;

    @Prop({ type: Object })
    private activeMenuItem!: MenuItem | null;

    @Prop({ type: String, default: '' })
    private campaignCode!: string;

    @Prop({ type: Array })
    private menuItems!: MenuItem[];

    @Prop({ type: Boolean, default: false })
    private useFlattenedCategoryTree!: boolean;

    private debouncedSendFacetsChangeEvent = debounce(this.sendFacetsChangeEvent, 70);

    @Watch('facets')
    onFacetsChange() {
        this.debouncedSendFacetsChangeEvent();
    }

    private sendFacetsChangeEvent() {
        bus.emit(MobileFacetsUpdateEventKey, { facets: this.facets });
    }

    get numberOfSelectedFacets(): number {
        const selectedFacets = (this.facets || []).filter(({ enabled }) => enabled)
            .reduce((count, { values }) => count + values.filter(({ selected }) => selected).length, 0);

        const selectedCategories = (this.menuItems || []).filter(({ selected }) => selected).length;

        return selectedFacets + selectedCategories;
    }

    private showOverlay() {
        mobileNavigationAndFacetsOverlay.show(
            this.contextKey,
            this.facets,
            this.rootMenuItem,
            this.activeMenuItem,
            this.campaignCode,
            this.menuItems,
            this.useFlattenedCategoryTree);
    }
}
